import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup.tsx';
import {
  optionAccountHolderStatus,
  optionAccountHolderStatusMap,
  showAccountHolderStatusGiin,
  tooltipPublicCompanyName,
  tooltipSecuritiesMarketName,
} from '~/modules/identification/forms/TaxResidencyAdditionalInformation/constants.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { TooltipInformer } from '~/components/InfoTooltip/Tooltip.tsx';
import { useFormContext, useWatch } from 'react-hook-form';
import { Grid } from '@mui/material';
import { MultilineTextInput } from '~/components/TextField/MultilineTextInput.tsx';

export const AccountHolderStatus = () => {
  const { setValue, trigger } = useFormContext();
  const selectedOption = useWatch({ name: 'accountHolderStatus.selectedOption' });

  const handleSelectedOptionChange = (value: string) => {
    if (!showAccountHolderStatusGiin.includes(value)) {
      setValue('accountHolderStatus.giin', null);
    }
    if (value !== optionAccountHolderStatus.option4) {
      setValue('accountHolderStatus.securitiesMarketName', null);
      setValue('accountHolderStatus.publicCompanyName', null);
    }
  };

  const handleSecuritiesMarketNameChange = () => {
    trigger('accountHolderStatus.publicCompanyName');
  };

  const handlePublicCompanyNameChange = () => {
    trigger('accountHolderStatus.securitiesMarketName');
  };

  return (
    <Grid container spacing={3}>
      <FormRadioGroup
        name="accountHolderStatus.selectedOption"
        options={optionAccountHolderStatusMap}
        onChange={handleSelectedOptionChange}
      />
      {showAccountHolderStatusGiin.includes(selectedOption) && (
        <FormGridItem>
          <FormInput
            name="accountHolderStatus.giin"
            label="Ідентифікаційний номер посередника (GIIN) Власника Рахунку"
            placeholder="Введіть ідентифікаційний номер посередника (GIIN) Власника Рахунку"
            fullWidth
          />
        </FormGridItem>
      )}
      {selectedOption === optionAccountHolderStatus.option4 && (
        <>
          <MultilineTextInput
            name="accountHolderStatus.securitiesMarketName"
            label={
              <TooltipInformer
                label={'Назва організованого ринку цінних паперів'}
                text={tooltipSecuritiesMarketName}
              />
            }
            placeholder="Вкажіть назву організованого ринку цінних паперів"
            textSize={500}
            onChange={handleSecuritiesMarketNameChange}
          />
          <MultilineTextInput
            name="accountHolderStatus.publicCompanyName"
            label={
              <TooltipInformer label={'Назва публічної компанії'} text={tooltipPublicCompanyName} />
            }
            placeholder="Вкажіть назву публічної компанії"
            textSize={500}
            onChange={handlePublicCompanyNameChange}
          />
        </>
      )}
    </Grid>
  );
};
